import { defineTextStyles } from '@chakra-ui/react';

const fontFamily = 'var(--font-montserrat)';

const TextStyles = defineTextStyles({
   xs: {
      value: {
         fontFamily,
         fontSize: 'xs',
         lineHeight: 'normal',
      },
   },
   sm: {
      value: {
         fontFamily,
         fontSize: 'sm',
         lineHeight: 'normal',
      },
   },
   md: {
      value: {
         fontFamily,
         fontSize: 'md',
         lineHeight: 'normal',
      },
   },
   lg: {
      value: {
         fontFamily,
         fontSize: 'lg',
         lineHeight: 'normal',
      },
   },
   xl: {
      value: {
         fontFamily,
         fontSize: 'xl',
         lineHeight: 'normal',
      },
   },
   '2xl': {
      value: {
         fontFamily,
         fontSize: '2xl',
         lineHeight: 'normal',
      },
   },
   '3xl': {
      value: {
         fontFamily,
         fontSize: '3xl',
         lineHeight: 'normal',
      },
   },
   '4xl': {
      value: {
         fontFamily,
         fontSize: '4xl',
         lineHeight: 'normal',
      },
   },
   '5xl': {
      value: {
         fontFamily,
         fontSize: '5xl',
         lineHeight: 'normal',
      },
   },
   '6xl': {
      value: {
         fontFamily,
         fontSize: '6xl',
         lineHeight: 'normal',
      },
   },
   '7xl': {
      value: {
         fontFamily,
         fontSize: '7xl',
         lineHeight: 'normal',
      },
   },
   '8xl': {
      value: {
         fontFamily,
         fontSize: '8xl',
         lineHeight: 'normal',
      },
   },
   '9xl': {
      value: {
         fontFamily,
         fontSize: '9xl',
         lineHeight: 'normal',
      },
   },
   '10xl': {
      value: {
         fontFamily,
         fontSize: '10xl',
         lineHeight: 'normal',
      },
   },
   '11xl': {
      value: {
         fontFamily,
         fontSize: '11xl',
         lineHeight: 'normal',
      },
   },
   '12xl': {
      value: {
         fontFamily,
         fontSize: '12xl',
         lineHeight: 'normal',
      },
   },
});

export default TextStyles;
